import React, { useEffect, useState } from 'react'

import { Tooltip } from '@mui/material'

import DataNotAvailable from '../../../../components/common/alerts/data-not-available/DataNotAvailable'
import { DaysTabs } from '../../../../components/events/common/DaysTabs/DaysTabs'
import CompetitorEventRegisterWrapper from '../../CompetitorEventRegisterWrapper'
import { RegisterItem } from './components/RegisterItem'

import RegistrationDyDayService from '../../../../services/firebase-service/registration-by-day/RegistrationDyDayService'

import useToasterHelper from '../../../../helpers/ToasterHelper'
import useEventRegister from '../../../../hooks/useEventRegister'
import { getDays } from '../../../../helpers/registration-on-event'
import { getCurrency } from '../../../../helpers/payment'

import { selectedEvent } from '../../../../store/events/eventsSlice'
import { useAppSelector } from '../../../../store/hooks'
import {
  selectRegisterTabData,
  selectTeamTabData,
} from '../../../../store/registration/registrationSlice'

import { IRegisterTab } from '../../../../models/event-registered-users/event-registered-users.interface'

// Styles
import './clinicNOtherReviewAndPayTab.css'

type IClinicNOtherRegisterTabProps = {
  title?: string
  description?: string
  handleModal: (showHide: boolean, typeOfModal: string, dataToPassOn?: any) => void
  eventId: string
}

export interface IHandleTeamMateChange {
  id: string
  currentClass: IRegisterTab
  removedUniqId?: string | null
}

const ClinicNOtherRegisterTab = (props: IClinicNOtherRegisterTabProps) => {
  const registerTabData = useAppSelector(selectRegisterTabData)
  const teamTabData = useAppSelector(selectTeamTabData)
  const selectedEventR = useAppSelector(selectedEvent)

  const toastFunction = useToasterHelper()

  const { onRegistrationRiderChange } = useEventRegister()

  const [days, setDays] = useState<string[]>([])
  const [activeDay, setActiveDay] = useState<string>('')
  const [registrationsCount, setRegistrationsCount] = useState<number>(0)

  useEffect(() => {
    const getEventRiders = async () => {
      const registeredUsers = await RegistrationDyDayService.getByEventIds([props.eventId])
      const registeredUsersWithoutScratched = registeredUsers.filter((rider) => !rider.isScratched)
      setRegistrationsCount(registeredUsersWithoutScratched.length)
    }
    getEventRiders().then()
  }, [props.eventId])

  const handleTeamMateChange = async ({
    id,
    currentClass,
    removedUniqId,
  }: IHandleTeamMateChange) => {
    const availableSpots = selectedEventR.EventFees?.registrationLimit?.spots
      ? +selectedEventR.EventFees.registrationLimit.spots
      : 0
    const isEnable = selectedEventR.EventFees?.registrationLimit?.isEnable

    let currentRegNum = 1 + registrationsCount

    registerTabData?.forEach((element) => {
      currentRegNum += element.registrationsByDay.length
    })

    if (isEnable && availableSpots < currentRegNum && !removedUniqId) {
      toastFunction.error({
        message: 'Event full. This event has reached its registration limit.',
      })

      return null
    }

    const member = teamTabData?.find((member) => member.memberId === id) || null

    await onRegistrationRiderChange({
      currentClass,
      member,
      removedUniqId,
    })
  }

  useEffect(() => {
    const { allDays } = getDays(registerTabData)
    setDays(allDays)
    if (!activeDay?.[0]) setActiveDay(allDays[0])
  }, [activeDay, registerTabData])

  const currency = getCurrency(selectedEventR?.EventPaymentSettings?.currency)

  return (
    <CompetitorEventRegisterWrapper title={props.title} description={props.description}>
      <div className={'flex justify-between gap-5 items-center'}>
        <DaysTabs activeDay={activeDay} setActiveDay={setActiveDay} days={days} />
        <Tooltip
          title={
            <h4 className="text-[12px] text-left max-w-[180px] leading-4">
              Extra fees you can select to pay when entering this class
            </h4>
          }
          placement="top-end"
          arrow
        >
          <p className="mb-6 text-[#122B46] text-[14px] underline hover:no-underline cursor-pointer">
            Extra fee?
          </p>
        </Tooltip>
      </div>

      <div className="flex flex-col gap-2">
        {registerTabData?.[0] ? (
          registerTabData.map((row, index) => {
            return (
              <RegisterItem
                key={index}
                row={row}
                handleTeamMateChange={handleTeamMateChange}
                handleModal={props.handleModal}
                eventId={props.eventId}
                activeDay={activeDay}
                EventFees={selectedEventR?.EventFees}
                currency={currency}
              />
            )
          })
        ) : (
          <DataNotAvailable
            mode="text"
            containerClassName="text-SeabiscuitDark200ThemeColor text-nr 2xl:text-base"
            text="No Classes have been added to this event"
          />
        )}
      </div>
    </CompetitorEventRegisterWrapper>
  )
}

export default ClinicNOtherRegisterTab
